import { CdkColumnDef } from '@angular/cdk/table';
import { NgModule } from '@angular/core';
import { DashboardClaim } from '@lsq-frontend/remote-services/enterprise/common';
import { CLAIMS } from '@lsq-frontend/common-ui';
import { LsqTablesModule } from '@lsq-frontend/common-ui';
import { AppCommonModule } from '../app-common.module';
import { LocalManagementRoutingModule } from './local-management-routing.module';
import { LsqUserStateManagementComponent } from './user-state/lsq-user-state-management.component';

@NgModule({
    imports: [LocalManagementRoutingModule, LsqTablesModule.forChild(), AppCommonModule],
    declarations: [LsqUserStateManagementComponent],
    providers: [CdkColumnDef, { provide: CLAIMS, useValue: DashboardClaim }]
})
export class LocalManagementModule {}
